<template>
  <div class="teachersignininfo-div">
    <div class="teacher-notice">签到情况如下：</div>
    <div class="classname">&nbsp;{{ classNameSet && classNameSet.join("，") }}</div>
    <van-tabs class="teachersignininfo-content" v-model="active" title-active-color="#333333" title-inactive-color="#999999">
      <van-tab v-for="(val, keyName, index) in stuList" :title="getTitle(keyName, val)" :key="'teachersignininfo-datacontent' + index">
        <div class="teachersignininfo-datalist" v-if="val.length > 0">
          <div class="studentname" v-for="(student, tempIndex) in val" :key="'studentname'+ tempIndex">
            {{student.name || ""}}
          </div>
        </div>
        <div class="bootscreen-emptydiv" v-else>
          <div class="emptydiv-imgdiv">
            <img class="emptydiv-img" src="../../../../public/img/product/bootScreen/img-zwqdxx.png" alt="">
          </div>
          <div class="emptydiv-text">暂无数据</div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
export default {
    data(){
        return{
            active: 0,
        }
    },
    props: {
    //所有学员的考勤情况
    stuList: {
      type: Object,
      default: ()=>{},
    },
    //当前所有班次
    classNameSet: {
      type: Array,
      default: ()=>[],
    },
  },
  methods:{
    getTitle(key, val) {
      var tar = "";
      switch (key) {
        case "notSignList":
          tar = "未签到";
          break;
        case "signList":
          tar = "出勤";
          break;
        case "leaveList":
          tar = "请假";
          break;
        case "shouldSignList":
          tar = "应到";
          break;
        default:
          break;
      }
      tar += " " + val.length;
      return tar;
    },
  }
}
</script>

<style>

</style>